import type { Ref } from "react";
import { t, when, whenShort } from "../i18n";
import type { NoteItem } from "../timeline";
import { Badge, type Names } from "./Badge";

// Notes, and a terminal share's chat, as a conversation (byj-1wv.51.3): what
// I wrote on the right, everyone else's on the left, each note a bubble of
// its own under who wrote it and when — the time short, the full one on
// hover — and a note on an event links to it.

export function Messages({ notes, names, me, onJump, listRef, className }: {
  notes: NoteItem[];
  names: Names;
  /** my user id: my notes are drawn on the right */
  me: string;
  onJump?: (seqs: readonly number[]) => void;
  listRef?: Ref<HTMLUListElement>;
  className?: string;
}) {
  return (
    <ul className={`messages${className ? ` ${className}` : ""}`} ref={listRef}>
      {notes.map((n) => {
        const mine = n.author.user === me;
        return (
          <li key={n.key} className={`msg${mine ? " mine" : ""}`}>
            <div className="msg-head">
              {mine ? <span className="msg-me">{t("common:you")}</span> : <Badge actor={n.author} names={names} />}
              {/* a recording's notes have no time: it keeps events, not frames */}
              {n.ts && (
                <time dateTime={n.ts} title={when(n.ts)}>
                  {whenShort(n.ts)}
                </time>
              )}
              {n.ref !== undefined && onJump && (
                <button className="link small" onClick={() => onJump([n.ref!])}>
                  #{n.ref}
                </button>
              )}
            </div>
            <p className="msg-body">{n.text}</p>
          </li>
        );
      })}
    </ul>
  );
}
